import { valueText } from "components/PayoutManagement/previews/styles";
import React from "react";
import { mutedText } from "styles";

interface IRenderAttributeProps {
  label: string;
  value: any;
}

const RenderAttribute: React.FC<IRenderAttributeProps> = ({ label, value }) => {
  return (
    <div className="flex flex-col">
      <div className={mutedText}>{label}</div>
      <div className={valueText}>{value}</div>
    </div>
  );
};

export default RenderAttribute;
